import { render, staticRenderFns } from "./team-carousel.vue?vue&type=template&id=3c29563d&"
import script from "./team-carousel.vue?vue&type=script&lang=js&"
export * from "./team-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports